import { motion } from "framer-motion";

const HOTEL_IMG =
  "https://images.pexels.com/photos/14841129/pexels-photo-14841129.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const FOUNDER_IMG = `${process.env.REACT_APP_BACKEND_URL}/api/files/zalta/uploads/products/7079acdc-53f8-452f-bb9d-9a8f5e72a551.jpeg`;

const stats = [
  { value: "10+", label: "Years manufacturing" },
  { value: "40+", label: "SKUs across 5 lines" },
  { value: "100%", label: "Direct factory-to-client" },
  { value: "4", label: "Institution types served" },
];

export const Trust = () => (
  <section id="trust" data-testid="trust-section" className="border-t border-[#221533]/10 bg-white">
    <div className="max-w-[1500px] mx-auto px-5 sm:px-6 lg:px-12 py-20 sm:py-28 lg:py-36 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
      >
        <p className="font-mono2 text-[11px] tracking-[0.35em] uppercase text-[#8E5A9E] mb-6">Why institutions choose ZALTA</p>
        <h2 className="font-clash text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.05] mb-8 text-[#221533]">
          The quiet partner behind<br /><span className="italic text-[#8E5A9E]">immaculate institutions.</span>
        </h2>
        <p className="text-[#221533]/60 font-light text-base lg:text-lg leading-relaxed max-w-lg mb-4">
          From the shampoo in a guest room to the auto scrubber in the corridor — everything your
          institution needs, from one trusted partner.
        </p>
        <p data-testid="trust-tagline" className="font-clash italic text-xl lg:text-2xl text-[#8E5A9E] mb-8">
          One manufacturer. One purchase order. One accountable standard.
        </p>
        <div data-testid="founder-card" className="flex items-center gap-5 mb-12 bg-white border border-[#221533]/10 rounded-xl p-4 sm:p-5 max-w-lg shadow-[0_15px_40px_-20px_rgba(142,90,158,0.35)]">
          <img
            src={FOUNDER_IMG}
            alt="Paramjeet Singh Ahluwalia — Founder, ZALTA"
            data-testid="founder-photo"
            className="w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover object-top border-2 border-[#8E5A9E]/40 shrink-0"
          />
          <div>
            <p className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-[#8E5A9E] mb-1.5">Founded &amp; led by</p>
            <p className="font-clash text-xl sm:text-2xl font-semibold text-[#221533] leading-tight">Paramjeet Singh Ahluwalia</p>
            <span className="inline-block mt-2 bg-[#8E5A9E] text-white font-manrope font-semibold text-xs sm:text-sm px-3.5 py-1.5 rounded-full">
              MBA (Finance &amp; Marketing)
            </span>
            <p className="text-sm text-[#221533]/55 font-light mt-2">Founder, ZALTA® · 10+ years in institutional hygiene</p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-px bg-[#221533]/10 border border-[#221533]/10 rounded-lg overflow-hidden">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              data-testid={`stat-${i}`}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className="bg-white p-6 lg:p-8"
            >
              <p className="font-clash text-4xl lg:text-5xl font-semibold text-[#8E5A9E]">{s.value}</p>
              <p className="font-mono2 text-[10px] tracking-[0.2em] uppercase text-[#221533]/45 mt-3">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
        className="relative border border-[#221533]/10 rounded-xl overflow-hidden shadow-[0_30px_80px_-30px_rgba(142,90,158,0.3)]"
      >
        <img src={HOTEL_IMG} alt="Institutional client — hotel lobby" className="w-full h-[380px] sm:h-[520px] object-cover" />
        <div className="absolute bottom-0 inset-x-0 bg-white/85 backdrop-blur-md border-t border-[#221533]/10 px-6 py-4 flex items-center justify-between">
          <span className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-[#221533]/70">Serving hospitality since 10+ years</span>
          <span className="font-clash text-lg text-[#74427F]">ZALTA<sup className="text-[#E63946] text-[10px]">®</sup></span>
        </div>
      </motion.div>
    </div>
  </section>
);
